module.exports = __webpack_public_path__ + "media/music/3fbd690bdae84637e34b8b933a164e3d.mp3";